// components/DynamicTable.jsx
import React, { useRef, useEffect, useState, useCallback } from "react";
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import icon_pen from '../img/icon_pen.png';
import icon_trash from '../img/icon_trash.png';
import icon_eye from '../img/icon_eye.png';
import icon_refresh from '../img/icon_refresh.png';
import icon_search from '../img/icon_search.png';
import icon_download from '../img/icon_download.png';
import icon_map_mode_1 from '../img/icon_mapmode1.png';
import icon_map_mode_2 from '../img/icon_mapmode2.png';
import icon_qr from '../img/icon_qr.png';
import {manage_call_result, download_document, view_document} from '../api/api';
import ConfirmModal from './ConfirmModal';

ModuleRegistry.registerModules([AllCommunityModule]);



//  Formatted version of a popular md5 implementation
//  Original copyright (c) Paul Johnston & Greg Holt.
//  The function itself is now 42 lines long.

function md5(inputString) {
    var hc="0123456789abcdef";
    function rh(n) {var j,s="";for(j=0;j<=3;j++) s+=hc.charAt((n>>(j*8+4))&0x0F)+hc.charAt((n>>(j*8))&0x0F);return s;}
    function ad(x,y) {var l=(x&0xFFFF)+(y&0xFFFF);var m=(x>>16)+(y>>16)+(l>>16);return (m<<16)|(l&0xFFFF);}
    function rl(n,c)            {return (n<<c)|(n>>>(32-c));}
    function cm(q,a,b,x,s,t)    {return ad(rl(ad(ad(a,q),ad(x,t)),s),b);}
    function ff(a,b,c,d,x,s,t)  {return cm((b&c)|((~b)&d),a,b,x,s,t);}
    function gg(a,b,c,d,x,s,t)  {return cm((b&d)|(c&(~d)),a,b,x,s,t);}
    function hh(a,b,c,d,x,s,t)  {return cm(b^c^d,a,b,x,s,t);}
    function ii(a,b,c,d,x,s,t)  {return cm(c^(b|(~d)),a,b,x,s,t);}
    function sb(x) {
        var i;var nblk=((x.length+8)>>6)+1;var blks=new Array(nblk*16);for(i=0;i<nblk*16;i++) blks[i]=0;
        for(i=0;i<x.length;i++) blks[i>>2]|=x.charCodeAt(i)<<((i%4)*8);
        blks[i>>2]|=0x80<<((i%4)*8);blks[nblk*16-2]=x.length*8;return blks;
    }
    var i,x=sb(""+inputString),a=1732584193,b=-271733879,c=-1732584194,d=271733878,olda,oldb,oldc,oldd;
    for(i=0;i<x.length;i+=16) {olda=a;oldb=b;oldc=c;oldd=d;
        a=ff(a,b,c,d,x[i+ 0], 7, -680876936);d=ff(d,a,b,c,x[i+ 1],12, -389564586);c=ff(c,d,a,b,x[i+ 2],17,  606105819);
        b=ff(b,c,d,a,x[i+ 3],22,-1044525330);a=ff(a,b,c,d,x[i+ 4], 7, -176418897);d=ff(d,a,b,c,x[i+ 5],12, 1200080426);
        c=ff(c,d,a,b,x[i+ 6],17,-1473231341);b=ff(b,c,d,a,x[i+ 7],22,  -45705983);a=ff(a,b,c,d,x[i+ 8], 7, 1770035416);
        d=ff(d,a,b,c,x[i+ 9],12,-1958414417);c=ff(c,d,a,b,x[i+10],17,     -42063);b=ff(b,c,d,a,x[i+11],22,-1990404162);
        a=ff(a,b,c,d,x[i+12], 7, 1804603682);d=ff(d,a,b,c,x[i+13],12,  -40341101);c=ff(c,d,a,b,x[i+14],17,-1502002290);
        b=ff(b,c,d,a,x[i+15],22, 1236535329);a=gg(a,b,c,d,x[i+ 1], 5, -165796510);d=gg(d,a,b,c,x[i+ 6], 9,-1069501632);
        c=gg(c,d,a,b,x[i+11],14,  643717713);b=gg(b,c,d,a,x[i+ 0],20, -373897302);a=gg(a,b,c,d,x[i+ 5], 5, -701558691);
        d=gg(d,a,b,c,x[i+10], 9,   38016083);c=gg(c,d,a,b,x[i+15],14, -660478335);b=gg(b,c,d,a,x[i+ 4],20, -405537848);
        a=gg(a,b,c,d,x[i+ 9], 5,  568446438);d=gg(d,a,b,c,x[i+14], 9,-1019803690);c=gg(c,d,a,b,x[i+ 3],14, -187363961);
        b=gg(b,c,d,a,x[i+ 8],20, 1163531501);a=gg(a,b,c,d,x[i+13], 5,-1444681467);d=gg(d,a,b,c,x[i+ 2], 9,  -51403784);
        c=gg(c,d,a,b,x[i+ 7],14, 1735328473);b=gg(b,c,d,a,x[i+12],20,-1926607734);a=hh(a,b,c,d,x[i+ 5], 4,    -378558);
        d=hh(d,a,b,c,x[i+ 8],11,-2022574463);c=hh(c,d,a,b,x[i+11],16, 1839030562);b=hh(b,c,d,a,x[i+14],23,  -35309556);
        a=hh(a,b,c,d,x[i+ 1], 4,-1530992060);d=hh(d,a,b,c,x[i+ 4],11, 1272893353);c=hh(c,d,a,b,x[i+ 7],16, -155497632);
        b=hh(b,c,d,a,x[i+10],23,-1094730640);a=hh(a,b,c,d,x[i+13], 4,  681279174);d=hh(d,a,b,c,x[i+ 0],11, -358537222);
        c=hh(c,d,a,b,x[i+ 3],16, -722521979);b=hh(b,c,d,a,x[i+ 6],23,   76029189);a=hh(a,b,c,d,x[i+ 9], 4, -640364487);
        d=hh(d,a,b,c,x[i+12],11, -421815835);c=hh(c,d,a,b,x[i+15],16,  530742520);b=hh(b,c,d,a,x[i+ 2],23, -995338651);
        a=ii(a,b,c,d,x[i+ 0], 6, -198630844);d=ii(d,a,b,c,x[i+ 7],10, 1126891415);c=ii(c,d,a,b,x[i+14],15,-1416354905);
        b=ii(b,c,d,a,x[i+ 5],21,  -57434055);a=ii(a,b,c,d,x[i+12], 6, 1700485571);d=ii(d,a,b,c,x[i+ 3],10,-1894986606);
        c=ii(c,d,a,b,x[i+10],15,   -1051523);b=ii(b,c,d,a,x[i+ 1],21,-2054922799);a=ii(a,b,c,d,x[i+ 8], 6, 1873313359);
        d=ii(d,a,b,c,x[i+15],10,  -30611744);c=ii(c,d,a,b,x[i+ 6],15,-1560198380);b=ii(b,c,d,a,x[i+13],21, 1309151649);
        a=ii(a,b,c,d,x[i+ 4], 6, -145523070);d=ii(d,a,b,c,x[i+11],10,-1120210379);c=ii(c,d,a,b,x[i+ 2],15,  718787259);
        b=ii(b,c,d,a,x[i+ 9],21, -343485551);a=ad(a,olda);b=ad(b,oldb);c=ad(c,oldc);d=ad(d,oldd);
    }
    return rh(a)+rh(b)+rh(c)+rh(d);
}





const DynamicTable = ({
  getColumnDefs,
  items,
  defaultColDef = {},
  onGridReady,
  gridOptions = {},
  deleteFunction,
  updateFunction,
  updateGrid = null,
  editCallback = null,
  className = "ag-theme-alpine",
  showDownloadButtons=true,
  disableButtonsWhenCreating=false,
  serverFilteringFunction=null,
  preventDelete=false,
  ...props
}) => {
  const gridRef = useRef(null);


  const [rowData, setRowData] = useState(items);
  const [recordToDelete, setRecordToDelete] = useState(-1);
  const [recordToEdit, setRecordToEdit] = useState(-1);
  const [recordToUpdate, setRecordToUpdate] = useState(-1);

  const [sortModel, setSortModel] = useState([]);

  useEffect(() => {
    setRowData(items);
  }, [items]);


  useEffect(() => {
    // Optional: do something with gridRef
  }, []);


  const sortHandler = useCallback(() => {
    const allColState = gridRef.current.api.getColumnState();
    const sortState = allColState
      .filter(col => col.sort)                          // keep only sorted columns
      .map(col => ({ colId: col.colId, sort: col.sort })); // extract relevant info

    setSortModel(sortState); // [{ colId: 'name', sort: 'desc' }]
    const querystring = document.getElementById('filter-text-box').value;
    if(serverFilteringFunction)
    {
      serverFilteringFunction(querystring, sortState); // optional: fetch new sorted data immediately
    }

  }, []);


  const onFilterTextBoxChanged = () => {

    const querystring = document.getElementById('filter-text-box').value;
    if(serverFilteringFunction){
       if(querystring.length>0 && querystring.length<3){
            return;
       }
       serverFilteringFunction(querystring, sortModel);
       gridRef.current.api.paginationGoToPage(0);
    }
    else{
      gridRef.current.api.setGridOption('quickFilterText', querystring);
    }
  };



  const showEditButton = true;
  const showDownloadButton = true;
  const eyeIconCallback = true;
  const canEdit = true;


  const startEditing = () => {};
  const stopEditing = () => {};


  const downloadDocument = (doc) => {
    window.open(doc.document_url);
  };


  //broken
  const downloadDocumentNEW = (doc_id) => {
    download_document(doc_id);
  };



  const goToDetail = (doc) => {
    window.open(doc.document_url);
  };


  //broken
  const goToDetailNEW = (doc_id) => {
    view_document(doc_id);
  };





  const editingRow = () => {};


  const deleteRow = (rowId) => {
    const rowNode = gridRef.current.api.getRowNode(rowId);
    if (!rowNode) return;
    const rowData = rowNode.data;
    gridRef.current.api.applyTransaction({ remove: [rowData] });
    setRowData((prev) => prev.filter((row) => row.id !== rowData.id));
  };


  const handleDeleteConfirm = async (rowId) => {
    const rowNode = gridRef.current.api.getRowNode(rowId);
    if (!rowNode) return;

    const rowData = rowNode.data;
    const res = await deleteFunction(rowData.id);
    const ok = manage_call_result(res);
    setRecordToDelete(-1);

    if(ok){
      deleteRow(rowId);
    }
  };



  const handleDeleteCancel = () => setRecordToDelete(-1);




  const handleEditCallback = useCallback((id) => {
    editCallback(id);
  }, [rowData]);



  const updateRow = (rowId) => {
    const rowNode = gridRef.current.api.getRowNode(rowId);
    const rowData = rowNode.data;
    //todo something ehre i guess
  };


  const handleUpdateConfirm = async (rowId) => {
    const rowNode = gridRef.current.api.getRowNode(rowId);
    const rowData = rowNode.data;
    const res = await updateFunction(rowData.id);
    const ok = manage_call_result(res);
    setRecordToUpdate(-1);

    if(ok){
      updateRow(rowId);
    }
  };

  const handleUpdateCancel = () => setRecordToUpdate(-1);



  const loadAndShowDescriptionDocumentsAndImages = () => {};


  const getMergedColumnDefs = () => ([
    ...getColumnDefs(startEditing, stopEditing, setRecordToDelete, setRecordToUpdate, goToDetail),
    {
      headerName: 'Azioni',
      field: 'actions',
      cellRenderer: (params) => {
        const { startEditing, stopEditing, setRecordToDelete, goToDetail } = params.context;
        const id = params.data.id;
        const status = params.data.status;
        const rowIndex = params.node.rowIndex;

        return (
          <div>
            { showDownloadButtons && eyeIconCallback && <img alt="icon_eye" src={icon_eye} className={`edit-icon edit-icon-${id}`}
               onClick={
                 () => {
                   if(status=="in_progress") return;
                   //goToDetail(id)
                   goToDetail(params.data)
                 }
               }
            style={{ width: '40px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { showDownloadButtons && canEdit && <img alt="icon_refresh" src={icon_refresh} className={`edit-icon edit-icon-${id}`}
               onClick={
                 () => {
                   if(status=="in_progress") return;
                   setRecordToUpdate(id)
                  }
               }
               style={{ width: '36px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { showDownloadButtons &&showDownloadButton && <img alt="icon_download" src={icon_download} className={`edit-icon edit-icon-${id}`}
              onClick={
                () => {
                  if(status=="in_progress") return;
                  //downloadDocument(id)
                  downloadDocument(params.data)
                }
              }
              style={{ width: '34px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { !showDownloadButtons && canEdit && <img alt="icon_pen" src={icon_pen} className={`edit-icon edit-icon-${id}`}
              onClick={
                () => {
                  if(status=="in_progress") return;
                  handleEditCallback(id)
                }
              }
              style={{ width: '36px', cursor: 'pointer', padding: '4px 8px' }} />}
            { canEdit && !preventDelete && <img alt="icon_trash" src={icon_trash} className={`edit-icon edit-icon-${id}`}
              onClick={
                () => {
                  //if(status=="in_progress") return;
                  setRecordToDelete(id)
                }
              }
              style={{ width: '32px', cursor: 'pointer', padding: '4px 8px' }} /> }
          </div>
        );
      },
      editable: false,
      sortable: false
    }
  ]);

  return (
    <div className={className} style={{ width: "100%", height: "700px"}}>


      <div className="dynamic-table-topbar-left">

        <img className="icon-search" src={icon_search} alt="search" />
        <input type="text" id="filter-text-box" className="filter-text-box" onInput={onFilterTextBoxChanged} />
      </div>

      <AgGridReact
        ref={gridRef}
        rowData={rowData}
        context={{ startEditing, stopEditing, deleteRow, setRecordToDelete, goToDetail, editingRow }}
        gridOptions={{
          columnDefs: getMergedColumnDefs(),
          pagination: true,
          rowHeight: 60,
          paginationPageSize: 10,
          paginationPageSizeSelector: [10, 20, 50, 100],
          suppressClickEdit: true,
          getRowId: params => params.data.id,
          onSortChanged:sortHandler,
          getRowStyle: params => {
            switch (params.data.status) {
              case "done":
                return { backgroundColor: "#ffffff" }; // light green
              case "error":
                return { backgroundColor: "#ffdddd" }; // light yellow
              case "in_progress":
                return { backgroundColor: "#e3e3e3" }; // light blue
              default:
                return null;
            }}
        }}

      />


      {recordToDelete !== -1 && (
        <ConfirmModal
          message={`Eliminare il record?`}
          onConfirm={() => handleDeleteConfirm(recordToDelete)}
          onCancel={handleDeleteCancel}
        />
      )}


      {recordToUpdate !== -1 && (
        <ConfirmModal
          message={`Aggiornare il record?`}
          onConfirm={() => handleUpdateConfirm(recordToUpdate)}
          onCancel={handleUpdateCancel}
        />
      )}



    </div>
  );
};


export default DynamicTable;
